import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "../../../providers/withRouter";
import { alpha, styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import { Link } from "react-router-dom";
import InfoTooltip from "../../../components/InfoTooltip";
import {
  subirDocumentacionProveedor,
  verDocumentacion,
  validarDocumentacion,
} from "../../../providers/documentos";
import { actualizarNoProcedeDoc } from "../../../services/docs.service";
import Add from "../../../icons/add.svg";
import Editar from "../../../icons/editar.svg";
import ControlledAccordions from "./accAAFFCom";
import ModalEditar from "./editarDatosProv";
import {
  getProveedor,
  getServicios,
  sendEmailDocsCad,
} from "../../../services";
import CircularProgress from "@mui/material/CircularProgress";
import {
  daysDiff,
  formatoFechasEs,
  eliminarComentario,
  editarComentario,
  cambiarFormatoNombre,
} from "../../../functions/funciones";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import { TiArrowBack } from "react-icons/ti";
import { UsuarioContext } from "../../../providers/userContext";
import DeclRes from "../../../components/proveedores/declRes";
import { createComment } from "../../../services/comment.service";
import Delete from "../../../icons/delete.svg";
import Delegations from "../../../components/suppliers/delegations";
import { IoSave } from "react-icons/io5";
import ModalEditarComentarios from "./../../../components/suppliers/AllComments";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import Comentarios from "../../../components/proveedores/comentarios";
import Trabajadores from "../../../components/suppliers/Trabajadores";
import Excel from "../../../icons/excel.svg"
import { getAaffSuppServExcel } from "../../../services/aaffs.service";
import { getReclamacionesProveedor } from "../../../services/proveedor.service";
import ReclamacionesTimeline from "../../../components/proveedores/ReclamacionesTimeline";

const CustomSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase": {
    color: "#FF5252",
    "&:hover": {
      backgroundColor: alpha("#FF5252", theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-switchBase + .MuiSwitch-track": {
    backgroundColor: "#FF5252",
  },
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#7bc977",
    backgroundColor: alpha("#7bc977", theme.palette.action.hoverOpacity),
    "&:hover": {
      backgroundColor: alpha("#7bc977", theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#7bc977",
  },
}));

const CustomPendienteSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase": {
    color: "#FFD700",
  },
  "& .MuiSwitch-switchBase + .MuiSwitch-track": {
    backgroundColor: "#FFD700",
  },
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#FFD700",
    backgroundColor: alpha("#FFD700", theme.palette.action.hoverOpacity),
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#FFD700",
  },
}));

const ProveedorDatos = (props) => {
  const { t } = useTranslation(['suppliers', 'common']);
  const delegations = 0;
  const user = useContext(UsuarioContext);
  const [aaff, setAAFF] = useState([]);
  const [fincas, setFincas] = useState([]);
  const [proveedor, setProveedor] = useState({});
  const [servicios, setServicios] = useState([]);
  const [recargar, setRecargar] = useState(false);
  const [modalEditarOpened, setModalEditarOpened] = useState(false);
  const [modalCommentsOpened, setModalCommentsOpened] = useState(false);
  const [comentarios, setComentarios] = useState([]);
  const [comentario, setComentario] = useState("");
  const [mostrarTrabajadores, setMostrarTrabajadores] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingXls, setLoadingXls] = useState(false);
  const estados = JSON.parse(localStorage.getItem("statesSupps")) || [];
  const estadoProveedor = estados.find((e) => e.id === proveedor?.estado_id);
  const [reclamaciones, setReclamaciones] = useState([]);
  const [loadingReclamaciones, setLoadingReclamaciones] = useState(true);
  const hijoAPadre = () => {
    setRecargar(!recargar);
  };

  useEffect(() => {
    fetchData();
  }, [!recargar]);

  useEffect(() => {
    if (!proveedor?.id) return;
    setLoadingReclamaciones(true);
    getReclamacionesProveedor(proveedor.id)
      .then((res) => setReclamaciones(Array.isArray(res) ? res : []))
      .catch(() => setReclamaciones([]))
      .finally(() => setLoadingReclamaciones(false));
  }, [proveedor?.id]);

  const fetchData = async () => {
    const responseServ = await getServicios();
    setServicios(responseServ);
    const responseProv = await getProveedor(props.params.nifProveedor);
    setProveedor(responseProv);
    const comments =
      responseProv?.comments?.length > 0
        ? responseProv?.comments?.map((comment) => {
          comment.usuario =
            comment.user?.consultant?.[0] || comment.user?.admin?.[0] || comment.user?.technician?.[0];
          return comment;
        })
        : [];
    setComentarios(comments);
    setIsLoading(false);
  };

  const handleSubirDocsCallback = () => {
    setRecargar(!recargar);
  };

  const comprobarArchivos = async (
    validado,
    status,
    ruta,
    id,
    idDoc,
    rol,
    nif,
    noProcede = false
  ) => {
    // Llama a la función importada y pasa la devolución de llamada
    // console.log("comprobarArchivos", validado, status, ruta, id, idDoc, rol, nif);
    if (validado && status) {
      verDocumentacion(ruta, id, idDoc, rol, nif, noProcede).then((resultado) => {
        handleSubirDocsCallback(resultado);
      });
    } else {
      subirDocumentacionProveedor(ruta, id, idDoc, rol, nif, noProcede).then(
        (resultado) => {
          handleSubirDocsCallback(resultado);
        }
      );
    }
  };

  const comprobarValidacion = async (ruta, idDoc, nif, idtypeDoc = null) => {
    validarDocumentacion(ruta, idDoc, nif, idtypeDoc).then((resultado) => {
      handleSubirDocsCallback(resultado);
    });
  };

  const handleNoProcede = async (tipoDoc, nif, currentNoProcede) => {
    const rolesNoProcede = ["ADMIN", "CONSUL", "VENT"];
    if (!rolesNoProcede.includes(user.rol)) return;

    let noProcede = currentNoProcede;

    const { value: formValues } = await Swal.fire({
      title: t('statusUpdate.uploadDocumentation'),
      html: `<div id="switch-container" style="display: flex; align-items: center; justify-content: center; margin: 20px 0; gap: 10px;"><span style="font-weight: 500; font-size: 14px;">${t('detail.notApplicable')}</span><div id="switch-mount"></div></div>`,
      showCancelButton: true,
      confirmButtonText: t('common:actions.save'),
      confirmButtonColor: "rgb(130, 130, 130)",
      cancelButtonText: t('common:actions.cancel'),
      didOpen: () => {
        const switchMount = document.getElementById('switch-mount');
        if (switchMount) {
          const { createRoot } = require('react-dom/client');
          const root = createRoot(switchMount);

          const SwitchComponent = () => {
            const [checked, setChecked] = React.useState(noProcede);

            const handleChange = (e) => {
              setChecked(e.target.checked);
              noProcede = e.target.checked;
            };

            return React.createElement(CustomSwitch, {
              checked: checked,
              onChange: handleChange
            });
          };

          root.render(React.createElement(SwitchComponent));
        }
      },
      preConfirm: () => {
        return { noProcede: noProcede };
      },
    });

    if (formValues) {
      const nuevoNoProcede = formValues.noProcede;
      const toastInfo = toast.info(t('statusUpdate.updating'), { autoClose: false });
      try {
        await actualizarNoProcedeDoc(nif, tipoDoc, nuevoNoProcede);
        toast.update(toastInfo, {
          render: t('statusUpdate.success'),
          type: toast.TYPE.SUCCESS,
          autoClose: true,
        });
        handleSubirDocsCallback();
      } catch (err) {
        console.log(err);
        toast.update(toastInfo, {
          render: t('statusUpdate.error'),
          type: toast.TYPE.ERROR,
          autoClose: true,
        });
      }
    }
  };

  const editarComment = async (id, comm) => {
    editarComentario(id, user.id, comm).then((resultado) => {
      handleSubirDocsCallback(resultado);
    });
  };
  const eliminarComment = async (id) => {
    eliminarComentario(id).then((resultado) => {
      handleSubirDocsCallback(resultado);
    });
  };
  const generateComunidadesExcel = async () => {
    const { nifProveedor } = props.params;
    const toastId = toast.loading(t('excel.generating'));
    setLoadingXls(true);
    try {
      const data = await getAaffSuppServExcel(nifProveedor);
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `comunidades_proveedor_${nifProveedor}_${Date.now()}.xlsx`);
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
      toast.update(toastId, {
        render: t('excel.downloadSuccess'),
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      setLoadingXls(false);
    } catch (error) {
      console.log(error);
      toast.update(toastId, {
        render: t('excel.downloadError'),
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
      setLoadingXls(false);
    }
  };
  function guardarComentarios() {
    try {
      let infoComentario = {
        prop_id: null,
        supp_id: proveedor.id,
        aaff_id: null,
        texto: comentario,
        tipo: "comment",
        status: 1,
      };
      createComment(infoComentario).then((res) => {
        handleSubirDocsCallback(res);
        setComentario("");
      });
    } catch (error) {
      console.log(error);
    }
  }

  const handleSendEmail = async () => {
    return new Promise(async (resolve, reject) => {
      try {
        const result = await Swal.fire({
          title: t('email.sendExpiredDocsTitle'),
          text: t('email.sendExpiredDocsText'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#33dd75",
          cancelButtonColor: "#888",
          confirmButtonText: t('email.send'),
          cancelButtonText: t('common:actions.cancel'),
        });

        if (result.isConfirmed) {
          const toastInfo = toast.info(
            t('email.sending'),
            { autoClose: false }
          );
          await sendEmailDocsCad(
            user.id,
            props.params.nifProveedor,
            aaff.razonSocial,
            proveedor.user.email
          )
            .then((res) => {
              res.forEach((item) => {
                if (item.status === 200) {
                  toast.update(toastInfo, {
                    render: item.msg,
                    type: toast.TYPE.SUCCESS,
                    autoClose: true,
                  });
                  resolve(true);
                } else {
                  toast.update(toastInfo, {
                    render: item.msg,
                    type: toast.TYPE.ERROR,
                    autoClose: true,
                  });
                }
              });
            })
            .catch((error) => {
              console.log(error);
              toast.update(toastInfo, {
                render: t('email.sendError'),
                type: toast.TYPE.ERROR,
                autoClose: true,
              });
              reject(error);
            });
        } else {
          // Si el usuario cancela la eliminación
          resolve(false);
        }
      } catch (error) {
        console.error("Error al enviar email:", error);
        reject(error);
      }
    });
  };

  function cambiarComentarios(evt) {
    const value = evt.target.value;
    setComentario(value);
  }

  const redirectToSomeRoute = (nif) => {
    setIsLoading(true);
    setRecargar(!recargar);
    props.navigate(`/proveedores/${nif}`);
  };

  return isLoading ? (
    <CircularProgress
      style={{
        color: "#92004D",
        position: "absolute",
        top: "50%",
        left: "50%",
      }}
    />
  ) : (
    <>
      <ModalEditarComentarios
        comentarios={comentarios}
        opened={modalCommentsOpened}
        eliminarComment={eliminarComment}
        editarComment={editarComment}
        handleClose={() => {
          setModalCommentsOpened(false);
          setRecargar(!recargar);
        }}
      />
      <ModalEditar
        proveedor={proveedor}
        servicios={servicios}
        opened={modalEditarOpened}
        hijoAPadre={hijoAPadre}
        handleClose={() => {
          setModalEditarOpened(false);
          setRecargar(!recargar);
        }}
      />
      <BreadCrumb
        rutas={[
          { path: "/proveedores", label: t('title') },
          {
            path: `proveedores/${proveedor.nif}`,
            label: `${proveedor.razonSocial}`,
          },
        ]}
      />
      <div className="pageGrid">
        <div className="gridCard">
          <div className="gridHead">
            {t('sections.generalInfo')}
            <Link to={`/proveedores`}>
              <div className="gridHeadRight">
                {/* {"<< volver al listado de Proveedores"} */}
                <TiArrowBack style={{ fontSize: 23 }} />
              </div>
            </Link>
          </div>
          <div className="gridSubhead editarSubhead">
            <div>{t('sections.companyData')}</div>
            <div
              className="editarBtn"
              onClick={() => setModalEditarOpened(true)}
            >
              <span style={{ marginRight: 10 }}>{t('common:actions.edit')}</span>{" "}
              <img src={Editar} alt={t('common:actions.edit')} />
            </div>
          </div>
          <div className="datosGrid">
            <p>
              <b>{t('detail.supplierName')}</b> {proveedor.razonSocial}
            </p>
            <p>
              <b>{t('detail.address')}</b> {proveedor.direccion}
            </p>
            <p>
              <b>{t('detail.nif')}</b> {proveedor.nif}
            </p>
            <p>
              <b>{t('detail.municipality')}</b> {cambiarFormatoNombre(proveedor.municipio)}
            </p>
            <p>
              <b>{t('detail.contactPerson')}</b> {proveedor?.nombreContacto}
            </p>
            <p>
              <b>{t('detail.postalCode')}</b> {proveedor?.codigoPostal}
            </p>
            <p>
              <b>{t('detail.contactEmail')}</b> {proveedor?.emailContacto}
            </p>
            <p>
              <b>{t('detail.province')}</b> {proveedor?.provincia}
            </p>
            <p>
              <b>{t('detail.loginEmail')}</b> {proveedor.user?.email}
            </p>
            <p>
              <b>{t('detail.phone')}</b> {proveedor?.telefonoContacto}
            </p>
            <p>
              <b>{t('detail.createdAt')}</b>{" "}
              {new Date(proveedor.createdAt).toLocaleDateString()}
            </p>
            <p>
              <b>{t('detail.lastReclamation')}</b>{" "}
              {proveedor.ultimaReclamacion === undefined ||
                proveedor.ultimaReclamacion === null
                ? new Date(proveedor.createdAt).toLocaleDateString()
                : new Date(proveedor.ultimaReclamacion).toLocaleDateString()}
            </p>
            <p><b>{t('common:filters.service')}:</b> {proveedor.serviceSupps?.map(s => s.nombre).join(', ') || []}</p>
            {/* <p><b>{t('common:filters.service')}:</b> {fincas.proveedores.servicio <= 18 ? serviciosProveedores[fincas.proveedores.servicio] : "Desconocido"}</p> */}
            <p>
              <b>{t('detail.nextReclamation')}</b>{" "}
              {proveedor.proximaReclamacion
                ? new Date(proveedor.proximaReclamacion).toLocaleDateString()
                : "-"}
            </p>
            <p>
              <b>{t('detail.state')}</b>{" "}
              {estadoProveedor
                ? t(`common:stateNamesSupps.${estadoProveedor.nombre}`, estadoProveedor.nombre)
                : "-"}
            </p>
            <p>
              <b>{t('detail.standby')}</b>{" "}
              {proveedor.standBy === null || proveedor.standBy === undefined
                ? "-"
                : proveedor.standBy ? t('common:status.yes') : t('common:status.no')}
            </p>
          </div>
          <div className="datosGrid">
            <div></div>
            <div style={{ display: "flex", justifyContent: "end" }}>
              <button
                onClick={() => handleSendEmail()}
                style={{
                  margin: "10px 0",
                  borderRadius: "5px 5px",
                  backgroundColor: "#92004D",
                  color: "#ffffff",
                  padding: "5px 10px",
                }}
              >
                {t('email.expiredDocs')}
              </button>
            </div>
          </div>
          {user.rol === "AAFF" && (
            <div style={{ margin: "10px 20px" }}>
              <ReclamacionesTimeline fechas={reclamaciones} loading={loadingReclamaciones} t={t} />
            </div>
          )}
          <div className="datosGrid">
            <Comentarios supp={proveedor} />
          </div>
          <div className="gridSubhead">{t('sections.companyDocuments')}</div>
          <div className="tableContainer">
            <table>
              <colgroup>
                <col style={{ width: '12.5%' }} />
                <col style={{ width: '12.5%' }} />
                <col style={{ width: '12.5%' }} />
                <col style={{ width: '12.5%' }} />
                <col style={{ width: '12.5%' }} />
                <col style={{ width: '12.5%' }} />
                <col style={{ width: '12.5%' }} />
                <col style={{ width: '12.5%' }} />
              </colgroup>
              <thead>
                {/* LOS TITULOS TIENEN QUE IR ACORDE CON LOS DOCUMENTOS DE ABAJO */}
                <tr>
                  <th style={{ textAlign: "center" }}>
                    <InfoTooltip title={t('documentTypes.rcFull')}>
                      {t('documentTypes.rc')}
                    </InfoTooltip>
                  </th>
                  <th style={{ textAlign: "center" }}>{t('documentTypes.preventiveModality')}</th>
                  <th style={{ textAlign: "center" }}>{t('documentTypes.riskAssessment')}</th>
                  <th style={{ textAlign: "center" }}>{t('documentTypes.preventivePlanning')}</th>
                  <th style={{ textAlign: "center" }}>{t('documentTypes.workersList')}</th>
                  <th style={{ textAlign: "center" }}>
                    <InfoTooltip title={t('documentTypes.rlcFull')}>
                      {t('documentTypes.rlc')}
                    </InfoTooltip>
                  </th>
                  <th style={{ textAlign: "center" }}>
                    <InfoTooltip title={t('documentTypes.rntFull')}>
                      {t('documentTypes.rnt')}
                    </InfoTooltip>
                  </th>
                  <th style={{ textAlign: "center" }}>{t('documentTypes.socialSecurityCert')}</th>
                </tr>
              </thead>
              <tbody>
                {<tr>
                  {/* RC */}
                  <td style={{ textAlign: "center" }}>
                    {proveedor?.docssupps?.find((d) => d.tipoDoc === 2)
                      ?.pendiente &&
                      proveedor?.docssupps?.find((d) => d.tipoDoc === 2)
                        ?.status ? (
                      <CustomPendienteSwitch
                        checked={false}
                        onClick={() =>
                          comprobarValidacion(
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 2)
                              ?.ruta,
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 2)
                              ?.id,
                            proveedor.nif,
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 2)
                              ?.type?.id
                          )
                        }
                      />
                    ) : (
                      <CustomSwitch
                        checked={
                          proveedor?.docssupps?.find((d) => d.tipoDoc === 2)
                            ?.validado &&
                          proveedor?.docssupps?.find((d) => d.tipoDoc === 2)
                            ?.status
                        }
                        onClick={() =>
                          comprobarArchivos(
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 2)
                              ?.validado,
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 2)
                              ?.status,
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 2)
                              ?.ruta,
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 2)
                              ?.id,
                            2,
                            user.rol,
                            proveedor.nif
                          )
                        }
                      />
                    )}
                    <small style={{ display: "block" }}>
                      {proveedor?.docssupps?.find((d) => d.tipoDoc === 2)
                        ?.fechaCaducidad !== null &&
                        proveedor?.docssupps?.find((d) => d.tipoDoc === 2)
                          ?.status ? (
                        <span
                          style={{
                            color:
                              daysDiff(
                                new Date(
                                  proveedor?.docssupps?.find(
                                    (d) => d.tipoDoc === 2
                                  )?.fechaCaducidad
                                ),
                                new Date()
                              ) > 0
                                ? "red"
                                : "black",
                          }}
                        >
                          {new Date(
                            proveedor?.docssupps?.find(
                              (d) => d.tipoDoc === 2
                            )?.fechaCaducidad
                          ).toLocaleDateString()}
                        </span>
                      ) : (
                        "-"
                      )}
                    </small>
                  </td>
                  {/* Modalidad preventiva */}
                  <td style={{ textAlign: "center" }}>
                    {proveedor?.noProcede ? (
                      t('detail.notApplicable')
                    ) : (
                      <>
                        {proveedor?.docssupps?.find((d) => d.tipoDoc === 3)
                          ?.pendiente ? (
                          <CustomPendienteSwitch
                            checked={false}
                            onClick={() =>
                              comprobarValidacion(
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 3
                                )?.ruta,
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 3
                                )?.id,
                                proveedor.nif,
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 3
                                )?.type?.id
                              )
                            }
                          />
                        ) : (
                          <CustomSwitch
                            checked={
                              proveedor?.docssupps?.find((d) => d.tipoDoc === 3)
                                ?.validado
                            }
                            onClick={() =>
                              comprobarArchivos(
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 3
                                )?.validado,
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 3
                                )?.status,
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 3
                                )?.ruta,
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 3
                                )?.id,
                                3,
                                user.rol,
                                proveedor.nif
                              )
                            }
                          />
                        )}
                        <small style={{ display: "block" }}>
                          {proveedor?.docssupps?.find((d) => d.tipoDoc === 3)
                            ?.fechaCaducidad !== null &&
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 3)
                              ?.status ? (
                            <span
                              style={{
                                color:
                                  daysDiff(
                                    new Date(
                                      proveedor?.docssupps?.find(
                                        (d) => d.tipoDoc === 3
                                      )?.fechaCaducidad
                                    ),
                                    new Date()
                                  ) > 0
                                    ? "red"
                                    : "black",
                              }}
                            >
                              {new Date(
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 3
                                )?.fechaCaducidad
                              ).toLocaleDateString()}
                            </span>
                          ) : (
                            "-"
                          )}
                        </small>
                      </>
                    )}
                  </td>
                  {/* Evaluación de riesgos*/}
                  <td style={{ textAlign: "center" }}>
                    {proveedor?.docssupps?.find((d) => d.tipoDoc === 5)
                      ?.pendiente ? (
                      <CustomPendienteSwitch
                        checked={false}
                        onClick={() =>
                          comprobarValidacion(
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 5)
                              ?.ruta,
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 5)
                              ?.id,
                            proveedor.nif,
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 5)
                              ?.type?.id
                          )
                        }
                      />
                    ) : (
                      <CustomSwitch
                        checked={
                          proveedor?.docssupps?.find((d) => d.tipoDoc === 5)
                            ?.validado
                        }
                        onClick={() =>
                          comprobarArchivos(
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 5)
                              ?.validado,
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 5)
                              ?.status,
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 5)
                              ?.ruta,
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 5)
                              ?.id,
                            5,
                            user.rol,
                            proveedor.nif
                          )
                        }
                      />
                    )}
                    <small style={{ display: "block" }}>-</small>
                  </td>
                  {/* Planificación preventiva */}
                  <td style={{ textAlign: "center" }}>
                    {proveedor?.noProcede ? (
                      t('detail.notApplicable')
                    ) : (
                      <>
                        {proveedor?.docssupps?.find((d) => d.tipoDoc === 4)
                          ?.pendiente ? (
                          <CustomPendienteSwitch
                            checked={false}
                            onClick={() =>
                              comprobarValidacion(
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 4
                                )?.ruta,
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 4
                                )?.id,
                                proveedor.nif,
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 4
                                )?.type?.id
                              )
                            }
                          />
                        ) : (
                          <CustomSwitch
                            checked={
                              proveedor?.docssupps?.find((d) => d.tipoDoc === 4)
                                ?.validado
                            }
                            onClick={() =>
                              comprobarArchivos(
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 4
                                )?.validado,
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 4
                                )?.status,
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 4
                                )?.ruta,
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 4
                                )?.id,
                                4,
                                user.rol,
                                proveedor.nif
                              )
                            }
                          />
                        )}
                        <small style={{ display: "block" }}>
                          {proveedor?.docssupps?.find((d) => d.tipoDoc === 4)
                            ?.fechaCaducidad !== null &&
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 4)
                              ?.status ? (
                            <span
                              style={{
                                color:
                                  daysDiff(
                                    new Date(
                                      proveedor?.docssupps?.find(
                                        (d) => d.tipoDoc === 4
                                      )?.fechaCaducidad
                                    ),
                                    new Date()
                                  ) > 0
                                    ? "red"
                                    : "black",
                              }}
                            >
                              {new Date(
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 4
                                )?.fechaCaducidad
                              ).toLocaleDateString()}
                            </span>
                          ) : (
                            "-"
                          )}
                        </small>
                      </>
                    )}
                  </td>
                  {/* Listado Trabajadores */}
                  <td style={{ textAlign: "center" }}>
                    {proveedor?.noProcede ? (
                      t('detail.notApplicable')
                    ) : (
                      <>
                        {proveedor?.docssupps?.find((d) => d.tipoDoc === 10)
                          ?.pendiente ? (
                          <CustomPendienteSwitch
                            checked={false}
                            onClick={() =>
                              comprobarValidacion(
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 10)
                                  ?.ruta,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 10)
                                  ?.id,
                                proveedor.nif,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 10)
                                  ?.type?.id
                              )
                            }
                          />
                        ) : (
                          <CustomSwitch
                            checked={
                              proveedor?.docssupps?.find((d) => d.tipoDoc === 10)
                                ?.validado
                            }
                            onClick={() =>
                              comprobarArchivos(
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 10)
                                  ?.validado,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 10)
                                  ?.status,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 10)
                                  ?.ruta,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 10)
                                  ?.id,
                                10,
                                user.rol,
                                proveedor.nif
                              )
                            }
                          />
                        )}
                        <small style={{ display: "block" }}>-</small>
                      </>
                    )}
                  </td>
                  {/* RLC */}
                  <td style={{ textAlign: "center" }}>
                    {proveedor?.noProcede ? (
                      <span style={{ color: "#000" }}>{t('detail.notApplicable')}</span>
                    ) : proveedor?.docssupps?.find((d) => d.tipoDoc === 9)?.noProcede === true || proveedor?.docssupps?.find((d) => d.tipoDoc === 9)?.noProcede === 1 ? (
                      ["ADMIN", "CONSUL", "VENT"].includes(user.rol) ? (
                        <span
                          style={{ cursor: "pointer", color: "#000" }}
                          onClick={() => handleNoProcede(9, proveedor.nif, true)}
                        >
                          {t('detail.notApplicable')}
                        </span>
                      ) : null
                    ) : (
                      <>
                        {proveedor?.docssupps?.find((d) => d.tipoDoc === 9)
                          ?.pendiente &&
                          proveedor?.docssupps?.find((d) => d.tipoDoc === 9)
                            ?.status ? (
                          <CustomPendienteSwitch
                            checked={false}
                            onClick={() =>
                              comprobarValidacion(
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 9)
                                  ?.ruta,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 9)
                                  ?.id,
                                proveedor.nif,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 9)
                                  ?.type?.id
                              )
                            }
                          />
                        ) : (
                          <CustomSwitch
                            checked={
                              proveedor?.docssupps?.find((d) => d.tipoDoc === 9)
                                ?.validado &&
                              proveedor?.docssupps?.find((d) => d.tipoDoc === 9)
                                ?.status
                            }
                            onClick={() =>
                              comprobarArchivos(
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 9)
                                  ?.validado,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 9)
                                  ?.status,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 9)
                                  ?.ruta,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 9
                                )?.id,
                                9,
                                user.rol,
                                proveedor.nif,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 9)?.noProcede
                              )
                            }
                          />
                        )}
                        <small style={{ display: "block" }}>
                          {proveedor?.docssupps?.find((d) => d.tipoDoc === 9)
                            ?.fechaCaducidad !== null &&
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 9)
                              ?.status ? (
                            <span
                              style={{
                                color:
                                  daysDiff(
                                    new Date(
                                      proveedor?.docssupps?.find(
                                        (d) => d.tipoDoc === 9
                                      )?.fechaCaducidad
                                    ),
                                    new Date()
                                  ) > 0
                                    ? "red"
                                    : "black",
                              }}
                            >
                              {new Date(
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 9
                                )?.fechaCaducidad
                              ).toLocaleDateString()}
                            </span>
                          ) : (
                            "-"
                          )}
                        </small>
                      </>
                    )}
                  </td>
                  {/*  RNT */}
                  <td style={{ textAlign: "center" }}>
                    {proveedor?.noProcede ? (
                      <span style={{ color: "#000" }}>{t('detail.notApplicable')}</span>
                    ) : proveedor?.docssupps?.find((d) => d.tipoDoc === 8)?.noProcede === true || proveedor?.docssupps?.find((d) => d.tipoDoc === 8)?.noProcede === 1 ? (
                      ["ADMIN", "CONSUL", "VENT"].includes(user.rol) ? (
                        <span
                          style={{ cursor: "pointer", color: "#000" }}
                          onClick={() => handleNoProcede(8, proveedor.nif, true)}
                        >
                          {t('detail.notApplicable')}
                        </span>
                      ) : null
                    ) : (
                      <>
                        {proveedor?.docssupps?.find((d) => d.tipoDoc === 8)
                          ?.pendiente &&
                          proveedor?.docssupps?.find((d) => d.tipoDoc === 8)
                            ?.status ? (
                          <CustomPendienteSwitch
                            checked={false}
                            onClick={() =>
                              comprobarValidacion(
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 8)
                                  ?.ruta,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 8)
                                  ?.id,
                                proveedor.nif,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 8)
                                  ?.type?.id
                              )
                            }
                          />
                        ) : (
                          <CustomSwitch
                            checked={
                              proveedor?.docssupps?.find((d) => d.tipoDoc === 8)
                                ?.validado &&
                              proveedor?.docssupps?.find((d) => d.tipoDoc === 8)
                                ?.status
                            }
                            onClick={() =>
                              comprobarArchivos(
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 8)
                                  ?.validado,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 8)
                                  ?.status,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 8)
                                  ?.ruta,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 8)
                                  ?.id,
                                8,
                                user.rol,
                                proveedor.nif,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 8)?.noProcede
                              )
                            }
                          />
                        )}
                        <small style={{ display: "block" }}>
                          {proveedor?.docssupps?.find((d) => d.tipoDoc === 8)
                            ?.fechaCaducidad !== null &&
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 8)
                              ?.status ? (
                            <span
                              style={{
                                color:
                                  daysDiff(
                                    new Date(
                                      proveedor?.docssupps?.find(
                                        (d) => d.tipoDoc === 8
                                      )?.fechaCaducidad
                                    ),
                                    new Date()
                                  ) > 0
                                    ? "red"
                                    : "black",
                              }}
                            >
                              {new Date(
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 8
                                )?.fechaCaducidad
                              ).toLocaleDateString()}
                            </span>
                          ) : (
                            "-"
                          )}
                        </small>
                      </>
                    )}
                  </td>
                  {/* Certificado Seg. Social */}
                  <td style={{ textAlign: "center" }}>
                    {proveedor?.docssupps?.find((d) => d.tipoDoc === 6)
                      ?.pendiente ? (
                      <CustomPendienteSwitch
                        checked={false}
                        onClick={() =>
                          comprobarValidacion(
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 6)
                              ?.ruta,
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 6)
                              ?.id,
                            proveedor.nif,
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 6)
                              ?.type?.id
                          )
                        }
                      />
                    ) : (
                      <CustomSwitch
                        checked={
                          proveedor?.docssupps?.find((d) => d.tipoDoc === 6)
                            ?.validado
                        }
                        onClick={() =>
                          comprobarArchivos(
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 6)
                              ?.validado,
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 6)
                              ?.status,
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 6)
                              ?.ruta,
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 6)
                              ?.id,
                            6,
                            user.rol,
                            proveedor.nif
                          )
                        }
                      />
                    )}
                    <small style={{ display: "block" }}>
                      {proveedor?.docssupps?.find((d) => d.tipoDoc === 6)
                        ?.fechaCaducidad !== null &&
                        proveedor?.docssupps?.find((d) => d.tipoDoc === 6)
                          ?.fechaCaducidad !== undefined ? (
                        <span
                          style={{
                            color:
                              daysDiff(
                                new Date(
                                  proveedor?.docssupps?.find(
                                    (d) => d.tipoDoc === 6
                                  )?.fechaCaducidad
                                ),
                                new Date()
                              ) > 0
                                ? "red"
                                : "black",
                          }}
                        >
                          {new Date(
                            proveedor?.docssupps?.find(
                              (d) => d.tipoDoc === 6
                            )?.fechaCaducidad
                          ).toLocaleDateString()}
                        </span>
                      ) : (
                        "-"
                      )}
                    </small>
                  </td>
                </tr>}
              </tbody>
            </table>
            {proveedor?.noProcede !== true && (
              <Trabajadores nifSupp={proveedor.nif} crear={true} fechaCaducidad={true} recargar={recargar} />
            )}
            <input type="file" id="fileElem" hidden></input>
          </div>
        </div>
        <div className="gridCard">
          <div className="gridHead">
            <span>{t('tabs.communities').toUpperCase()}</span>
            {!loadingXls ? (
              <img
                src={Excel}
                alt="Exportar Excel"
                style={{ 
                  filter: 'brightness(0) invert(1)', 
                  cursor: 'pointer', // Cambia el icono del mouse
                  transition: 'transform 0.2s ease' // Suaviza el efecto de hover
                }}
                onClick={() => generateComunidadesExcel(proveedor.id)}
                // Opcional: un pequeño efecto visual al pasar el mouse
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
              />
            ) : (
              <CircularProgress
                style={{ color: '#fff', width: '16px', height: '16px', marginRight: '10px' }}
              />
            )}
          </div>
          <ControlledAccordions
            aaff={aaff}
            proveedor={proveedor}
            fincas={fincas}
          />
        </div>
      </div>
      <div className="pageGrid mt-3">
        <DeclRes nifProv={props.params.nifProveedor} proveedor={proveedor} />

        <div
          className="gridCard" /* style={delegations > 0 ? { display: 'block' } : { display: 'none' }} */
        >
          <div className="gridHead">
            {proveedor.parent_id !== null
              ? t('parentSupplier')
              : t('delegations.title').toUpperCase()}
            {proveedor.parent_id === null && (
              <Link to={`/delegacion/nueva/${proveedor.id}`}>
                <div className="gridHeadRight">
                  <img src={Add} alt={t('common:actions.more')} width={15} />
                </div>
              </Link>
            )}
          </div>
          <table style={{ margin: 15 }}>
            <thead>
              <tr
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  textAlign: "center",
                }}
              >
                <th></th>
                {/* <th>Aviso</th> */}
              </tr>
            </thead>
            <tbody>
              <Delegations
                nif={props.params.nifProveedor}
                proveedor={proveedor}
                redirectToSomeRoute={redirectToSomeRoute}
              />
            </tbody>
          </table>
        </div>
      </div>
      <style jsx="true">{`
        .pageGrid {
          position: relative;
          top: 00px;
          margin: 0 10px;
          display: grid;
          grid-template-columns: 5fr 3fr;
          grid-gap: 20px;
        }

        .tableContainer table {
          width: 100%;
          table-layout: fixed;
          border-collapse: collapse;
        }

        .tableContainer th,
        .tableContainer td {
          padding: 8px;
          text-align: center;
          vertical-align: middle;
        }

        .tableContainer td small {
          font-size: 0.85em;
          white-space: nowrap;
        }
      `}</style>
    </>
  );
};

export default withRouter(ProveedorDatos);